import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getMessage } from 'util/locale';
import classNames from 'classnames';

// components
import { Spinner } from '@tcc/crate';
import ManagementZones from 'manual/ManagementZones';

const baseString = 'vra-management-zones-container';
class ManagementZonesLoader extends Component {

  componentDidMount() {
    this.props.onMount();
  }

  render() {
    const {
      areManagementZonesLoaded,
      hasPreviousPrescriptions,
      managementZones,
      onSelectManagementZones,
      selectedManagementZonesId,
      scriptType
    } = this.props;

    const classString = classNames({
      [`${baseString}`]: true,
      [`${baseString}--${scriptType}`]: true,
      'vra-create-script-screen': true
    });

    const content = areManagementZonesLoaded ? (
      <ManagementZones
        hasPreviousPrescriptions={hasPreviousPrescriptions}
        onSelectManagementZones={onSelectManagementZones}
        selectedManagementZonesId={selectedManagementZonesId}
        zones={managementZones}
      />
    ) : (
      <Spinner className='vra-management-zones-container-spinner' size='24' />
    );

    return (
      <section className={classString} data-test-id='script-create-zones'>
        <p>{getMessage('text__management-zones-intro')}</p>
        {content}
      </section>
    );
  }
}

ManagementZonesLoader.propTypes = {
  areManagementZonesLoaded: PropTypes.bool.isRequired,
  hasPreviousPrescriptions: PropTypes.bool,
  managementZones: PropTypes.array.isRequired,
  onMount: PropTypes.func.isRequired,
  onSelectManagementZones: PropTypes.func.isRequired,
  scriptType: PropTypes.string.isRequired,
  selectedManagementZonesId: PropTypes.string
};

export default ManagementZonesLoader;
